export const SET_COMPANY_CONFIG = "SET_COMPANY_CONFIG";
export const SET_WHITE_STAR_VALUES = "SET_WHITE_STAR_VALUES";
